/* eslint-disable array-callback-return */
import siteMessage from "@insite/client-framework/SiteMessage";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { ShipViaDto } from "@insite/client-framework/Types/ApiModels";

interface DataLayerItem {
    item_id: string;
    item_name: string;
    item_brand: string;
    item_list_id?: string;
    item_list_name?: string;
    price?: number;
    quantity: number | null;
    [key: string]: any;
}

const generateMultipleItemArray = (products: CartLineModel[]) => {
    const itemArr: DataLayerItem[] = [];
    products.forEach(product => {
        const obj: DataLayerItem = {
            item_id: product.erpNumber ?? "",
            item_name: product.altText,
            item_brand: product.brand?.name || "",
            item_list_id: product.productId || "",
            item_list_name: product?.properties?.categories || "",
            price: product.pricing?.unitNetPrice,
            quantity: product.qtyOrdered,
            vendor_name: product?.properties?.vendor || siteMessage("SunSource")
        };
        const categoriesArr: string[] =
            product && product.properties && product.properties.categories
                ? product.properties.categories.split(",")
                : [];
        let i = 1;
        if (categoriesArr[categoriesArr.length - 1] === "") {
            categoriesArr.pop();
        }
        if (categoriesArr.length !== 0) {
            const uniqueItems: Record<string, boolean> = {};
            for (const item of categoriesArr) {
                if (!uniqueItems[item]) {
                    if (i === 1) {
                        obj.item_category = item;
                        uniqueItems[item] = true;
                    } else {
                        obj[`item_category${i}`] = item;
                        uniqueItems[item] = true;
                    }
                    i++;
                }
            }
        }
        itemArr.push(obj);
    });
    return itemArr;
};

const generateDataLayer: any = (items: DataLayerItem[] | null, carrierService: ShipViaDto[], orderGrandTotal: string, currencyCode?: string) => {
    const dataLayer = (window as any).dataLayer || [];
    if (dataLayer) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "add_shipping_info",
            ecommerce: {
                shipping_tier: carrierService[0]?.description ?? "",
                items,
                value: orderGrandTotal,
                currency: currencyCode || "",
            },
        });
    }
    return dataLayer;
};

const generateDataLayerTypeTwo: any = (items: DataLayerItem[] | null, carrierService: string, orderGrandTotal?: string, currencyCode?: string) => {
    const dataLayer = (window as any).dataLayer || [];
    if (dataLayer) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "add_shipping_info",
            ecommerce: {
                shipping_tier: carrierService ?? "",
                items,
                value: orderGrandTotal,
                currency: currencyCode || "",
            },
        });
    }
    return dataLayer;
};

export const addShippingInfoDataLayer = (
    productArray: CartLineModel[] | null,
    carrierService: ShipViaDto[] | string,
    orderGrandTotal?: any,
    currencyCode?: string
) => {
    if (productArray) {
        const items = generateMultipleItemArray(productArray);
        // eslint-disable-next-line no-constant-condition
        if (typeof carrierService === "string") {
            return generateDataLayerTypeTwo(items, carrierService, orderGrandTotal, currencyCode);
        }
        return generateDataLayer(items, carrierService, orderGrandTotal, currencyCode);
    }
};
